// --- BEGIN AUTO-GENERATED FILE ---
//
// @IconsVersion: 1.0.0-alpha3
// @Generated: 2020-05-12T01:41:42.277Z
//
// This file is generated on each build. Do not edit this file!
import { pluginFactoryNoConfig } from '../utils/plugins'; // Icon helper component

import { BIcon } from './icon'; // Icon stacking component

import { BIconstack } from './iconstack';
import { // BootstrapVue custom icons
BIconBlank // Bootstrap icons
, BIconAlarm, BIconAlarmFill, BIconAlt, BIconApp, BIconAppIndicator, BIconArchive, BIconArchiveFill, BIconArrow90degDown, BIconArrow90degLeft, BIconArrow90degRight, BIconArrow90degUp, BIconArrowBarDown, BIconArrowBarLeft, BIconArrowBarRight, BIconArrowBarUp, BIconArrowClockwise, BIconArrowCounterclockwise, BIconArrowDown, BIconArrowDownLeft, BIconArrowDownRight, BIconArrowDownShort, BIconArrowLeft, BIconArrowLeftRight, BIconArrowLeftShort, BIconArrowRepeat, BIconArrowReturnLeft, BIconArrowReturnRight, BIconArrowRight, BIconArrowRightShort, BIconArrowUp, BIconArrowUpDown, BIconArrowUpLeft, BIconArrowUpRight, BIconArrowUpShort, BIconArrowsAngleContract, BIconArrowsAngleExpand, BIconArrowsCollapse, BIconArrowsExpand, BIconArrowsFullscreen, BIconArrowsMove, BIconAspectRatio, BIconAspectRatioFill, BIconAt, BIconAward, BIconAwardFill, BIconBackspace, BIconBackspaceFill, BIconBackspaceReverse, BIconBackspaceReverseFill, BIconBag, BIconBagFill, BIconBarChart, BIconBarChartFill, BIconBattery, BIconBatteryCharging, BIconBatteryFull, BIconBatteryHalf, BIconBell, BIconBellFill, BIconBlockquoteLeft, BIconBlockquoteRight, BIconBook, BIconBookHalf, BIconBookmark, BIconBookmarkCheck, BIconBookmarkDash, BIconBookmarkFill, BIconBookmarkPlus, BIconBookmarks, BIconBookmarksFill, BIconBootstrap, BIconBootstrapFill, BIconBootstrapReboot, BIconBoundingBox, BIconBoundingBoxCircles, BIconBoxArrowDown, BIconBoxArrowDownLeft, BIconBoxArrowDownRight, BIconBoxArrowInDown, BIconBoxArrowInDownLeft, BIconBoxArrowInDownRight, BIconBoxArrowInLeft, BIconBoxArrowInRight, BIconBoxArrowInUp, BIconBoxArrowInUpLeft, BIconBoxArrowInUpRight, BIconBoxArrowLeft, BIconBoxArrowRight, BIconBoxArrowUp, BIconBoxArrowUpLeft, BIconBoxArrowUpRight, BIconBraces, BIconBriefcase, BIconBriefcaseFill, BIconBrightnessAltHigh, BIconBrightnessAltHighFill, BIconBrightnessAltLow, BIconBrightnessAltLowFill, BIconBrightnessHigh, BIconBrightnessHighFill, BIconBrightnessLow, BIconBrightnessLowFill, BIconBrush, BIconBucket, BIconBucketFill, BIconBuilding, BIconBullseye, BIconCalendar, BIconCalendarFill, BIconCamera, BIconCameraVideo, BIconCameraVideoFill, BIconCapslock, BIconCapslockFill, BIconCardChecklist, BIconCardHeading, BIconCardImage, BIconCardList, BIconCardText, BIconCaretDown, BIconCaretDownFill, BIconCaretLeft, BIconCaretLeftFill, BIconCaretRight, BIconCaretRightFill, BIconCaretUp, BIconCaretUpFill, BIconChat, BIconChatDots, BIconChatDotsFill, BIconChatFill, BIconChatQuote, BIconChatQuoteFill, BIconChatSquare, BIconChatSquareDots, BIconChatSquareDotsFill, BIconChatSquareFill, BIconChatSquareQuote, BIconChatSquareQuoteFill, BIconCheck, BIconCheckAll, BIconCheckBox, BIconCheckCircle, BIconChevronBarContract, BIconChevronBarDown, BIconChevronBarExpand, BIconChevronBarLeft, BIconChevronBarRight, BIconChevronBarUp, BIconChevronCompactDown, BIconChevronCompactLeft, BIconChevronCompactRight, BIconChevronCompactUp, BIconChevronContract, BIconChevronDoubleDown, BIconChevronDoubleLeft, BIconChevronDoubleRight, BIconChevronDoubleUp, BIconChevronDown, BIconChevronExpand, BIconChevronLeft, BIconChevronRight, BIconChevronUp, BIconCircle, BIconCircleFill, BIconCircleHalf, BIconCircleSquare, BIconClipboard, BIconClipboardData, BIconClock, BIconClockFill, BIconClockHistory, BIconCloud, BIconCloudDownload, BIconCloudFill, BIconCloudUpload, BIconCode, BIconCodeSlash, BIconCollection, BIconCollectionFill, BIconCollectionPlay, BIconCollectionPlayFill, BIconColumns, BIconColumnsGap, BIconCommand, BIconCompass, BIconCone, BIconConeStriped, BIconController, BIconCreditCard, BIconCrop, BIconCursor, BIconCursorFill, BIconCursorText, BIconDash, BIconDashCircle, BIconDashCircleFill, BIconDashSquare, BIconDashSquareFill, BIconDiamond, BIconDiamondFill, BIconDiamondHalf, BIconDisplay, BIconDisplayFill, BIconDot, BIconDownload, BIconDroplet, BIconDropletFill, BIconDropletHalf, BIconEgg, BIconEggFill, BIconEggFried, BIconEject, BIconEjectFill, BIconEnvelope, BIconEnvelopeFill, BIconEnvelopeOpen, BIconEnvelopeOpenFill, BIconExclamation, BIconExclamationCircle, BIconExclamationCircleFill, BIconExclamationDiamond, BIconExclamationDiamondFill, BIconExclamationOctagon, BIconExclamationOctagonFill, BIconExclamationSquare, BIconExclamationSquareFill, BIconExclamationTriangle, BIconExclamationTriangleFill, BIconExclude, BIconEye, BIconEyeFill, BIconEyeSlash, BIconEyeSlashFill, BIconFile, BIconFileArrowDown, BIconFileArrowUp, BIconFileBreak, BIconFileCheck, BIconFileCode, BIconFileDiff, BIconFileEarmark, BIconFileEarmarkArrowDown, BIconFileEarmarkArrowUp, BIconFileEarmarkBreak, BIconFileEarmarkCheck, BIconFileEarmarkCode, BIconFileEarmarkDiff, BIconFileEarmarkMinus, BIconFileEarmarkPlus, BIconFileEarmarkRuled, BIconFileEarmarkSpreadsheet, BIconFileEarmarkText, BIconFileEarmarkZip, BIconFileMinus, BIconFilePlus, BIconFilePost, BIconFileRichtext, BIconFileRuled, BIconFileSpreadsheet, BIconFileText, BIconFileZip, BIconFiles, BIconFilesAlt, BIconFilm, BIconFilter, BIconFilterLeft, BIconFilterRight, BIconFlag, BIconFlagFill, BIconFolder, BIconFolderCheck, BIconFolderFill, BIconFolderMinus, BIconFolderPlus, BIconFolderSymlink, BIconFolderSymlinkFill, BIconFonts, BIconForward, BIconForwardFill, BIconFullscreen, BIconFullscreenExit, BIconFunnel, BIconFunnelFill, BIconGear, BIconGearFill, BIconGearWide, BIconGearWideConnected, BIconGem, BIconGeo, BIconGeoAlt, BIconGift, BIconGiftFill, BIconGraphDown, BIconGraphUp, BIconGrid, BIconGrid1x2, BIconGrid1x2Fill, BIconGrid3x2, BIconGrid3x2Gap, BIconGrid3x2GapFill, BIconGrid3x3, BIconGrid3x3Gap, BIconGrid3x3GapFill, BIconGridFill, BIconHammer, BIconHash, BIconHeart, BIconHeartFill, BIconHeartHalf, BIconHouse, BIconHouseDoor, BIconHouseDoorFill, BIconHouseFill, BIconHr, BIconImage, BIconImageAlt, BIconImageFill, BIconImages, BIconInbox, BIconInboxFill, BIconInboxes, BIconInboxesFill, BIconInfo, BIconInfoCircle, BIconInfoCircleFill, BIconInfoSquare, BIconInfoSquareFill, BIconIntersect, BIconJustify, BIconJustifyLeft, BIconJustifyRight, BIconKanban, BIconKanbanFill, BIconLaptop, BIconLayers, BIconLayersFill, BIconLayersHalf, BIconLayoutSidebar, BIconLayoutSidebarInset, BIconLayoutSidebarInsetReverse, BIconLayoutSidebarReverse, BIconLayoutSplit, BIconLayoutTextSidebar, BIconLayoutTextSidebarReverse, BIconLayoutTextWindow, BIconLayoutTextWindowReverse, BIconLayoutThreeColumns, BIconLayoutWtf, BIconLifePreserver, BIconLightning, BIconLightningFill, BIconLink, BIconLink45deg, BIconList, BIconListCheck, BIconListNested, BIconListOl, BIconListTask, BIconListUl, BIconLock, BIconLockFill, BIconMap, BIconMic, BIconMicFill, BIconMicMute, BIconMicMuteFill, BIconMoon, BIconMusicNote, BIconMusicNoteBeamed, BIconMusicNoteList, BIconMusicPlayer, BIconMusicPlayerFill, BIconNewspaper, BIconOctagon, BIconOctagonFill, BIconOctagonHalf, BIconOption, BIconOutlet, BIconPaperclip, BIconPause, BIconPauseFill, BIconPen, BIconPencil, BIconPencilSquare, BIconPentagon, BIconPentagonFill, BIconPentagonHalf, BIconPeople, BIconPeopleCircle, BIconPeopleFill, BIconPerson, BIconPersonBoundingBox, BIconPersonCheck, BIconPersonCheckFill, BIconPersonDash, BIconPersonDashFill, BIconPersonFill, BIconPersonLinesFill, BIconPersonPlus, BIconPersonPlusFill, BIconPersonSquare, BIconPhone, BIconPhoneLandscape, BIconPieChart, BIconPieChartFill, BIconPip, BIconPipFill, BIconPlay, BIconPlayFill, BIconPlug, BIconPlus, BIconPlusCircle, BIconPlusCircleFill, BIconPlusSquare, BIconPlusSquareFill, BIconPower, BIconPuzzle, BIconPuzzleFill, BIconQuestion, BIconQuestionCircle, BIconQuestionCircleFill, BIconQuestionDiamond, BIconQuestionDiamondFill, BIconQuestionOctagon, BIconQuestionOctagonFill, BIconQuestionSquare, BIconQuestionSquareFill, BIconReply, BIconReplyAll, BIconReplyAllFill, BIconReplyFill, BIconScrewdriver, BIconSearch, BIconServer, BIconShield, BIconShieldFill, BIconShieldLock, BIconShieldLockFill, BIconShieldShaded, BIconShift, BIconShiftFill, BIconShuffle, BIconSkipBackward, BIconSkipBackwardFill, BIconSkipEnd, BIconSkipEndFill, BIconSkipForward, BIconSkipForwardFill, BIconSkipStart, BIconSkipStartFill, BIconSlash, BIconSlashCircle, BIconSlashCircleFill, BIconSlashSquare, BIconSlashSquareFill, BIconSliders, BIconSoundwave, BIconSpeaker, BIconSquare, BIconSquareFill, BIconSquareHalf, BIconStar, BIconStarFill, BIconStarHalf, BIconStop, BIconStopFill, BIconStopwatch, BIconStopwatchFill, BIconSubtract, BIconSun, BIconTable, BIconTablet, BIconTabletLandscape, BIconTag, BIconTagFill, BIconTerminal, BIconTerminalFill, BIconTextCenter, BIconTextIndentLeft, BIconTextIndentRight, BIconTextLeft, BIconTextRight, BIconTextarea, BIconTextareaT, BIconThreeDots, BIconThreeDotsVertical, BIconToggleOff, BIconToggleOn, BIconToggles, BIconTools, BIconTrash, BIconTrash2, BIconTrash2Fill, BIconTrashFill, BIconTriangle, BIconTriangleFill, BIconTriangleHalf, BIconTrophy, BIconTv, BIconTvFill, BIconType, BIconTypeBold, BIconTypeH1, BIconTypeH2, BIconTypeH3, BIconTypeItalic, BIconTypeStrikethrough, BIconTypeUnderline, BIconUnion, BIconUnlock, BIconUnlockFill, BIconUpload, BIconViewList, BIconViewStacked, BIconVolumeDown, BIconVolumeDownFill, BIconVolumeMute, BIconVolumeMuteFill, BIconVolumeUp, BIconVolumeUpFill, BIconVr, BIconWallet, BIconWatch, BIconWifi, BIconWindow, BIconWrench, BIconX, BIconXCircle, BIconXCircleFill, BIconXDiamond, BIconXDiamondFill, BIconXOctagon, BIconXOctagonFill, BIconXSquare, BIconXSquareFill } from './icons'; // Icon component names for used in the docs

export var iconNames = [// BootstrapVue custom icon component names
'BIconBlank', // Bootstrap icon component names
'BIconAlarm', 'BIconAlarmFill', 'BIconAlt', 'BIconApp', 'BIconAppIndicator', 'BIconArchive', 'BIconArchiveFill', 'BIconArrow90degDown', 'BIconArrow90degLeft', 'BIconArrow90degRight', 'BIconArrow90degUp', 'BIconArrowBarDown', 'BIconArrowBarLeft', 'BIconArrowBarRight', 'BIconArrowBarUp', 'BIconArrowClockwise', 'BIconArrowCounterclockwise', 'BIconArrowDown', 'BIconArrowDownLeft', 'BIconArrowDownRight', 'BIconArrowDownShort', 'BIconArrowLeft', 'BIconArrowLeftRight', 'BIconArrowLeftShort', 'BIconArrowRepeat', 'BIconArrowReturnLeft', 'BIconArrowReturnRight', 'BIconArrowRight', 'BIconArrowRightShort', 'BIconArrowUp', 'BIconArrowUpDown', 'BIconArrowUpLeft', 'BIconArrowUpRight', 'BIconArrowUpShort', 'BIconArrowsAngleContract', 'BIconArrowsAngleExpand', 'BIconArrowsCollapse', 'BIconArrowsExpand', 'BIconArrowsFullscreen', 'BIconArrowsMove', 'BIconAspectRatio', 'BIconAspectRatioFill', 'BIconAt', 'BIconAward', 'BIconAwardFill', 'BIconBackspace', 'BIconBackspaceFill', 'BIconBackspaceReverse', 'BIconBackspaceReverseFill', 'BIconBag', 'BIconBagFill', 'BIconBarChart', 'BIconBarChartFill', 'BIconBattery', 'BIconBatteryCharging', 'BIconBatteryFull', 'BIconBatteryHalf', 'BIconBell', 'BIconBellFill', 'BIconBlockquoteLeft', 'BIconBlockquoteRight', 'BIconBook', 'BIconBookHalf', 'BIconBookmark', 'BIconBookmarkCheck', 'BIconBookmarkDash', 'BIconBookmarkFill', 'BIconBookmarkPlus', 'BIconBookmarks', 'BIconBookmarksFill', 'BIconBootstrap', 'BIconBootstrapFill', 'BIconBootstrapReboot', 'BIconBoundingBox', 'BIconBoundingBoxCircles', 'BIconBoxArrowDown', 'BIconBoxArrowDownLeft', 'BIconBoxArrowDownRight', 'BIconBoxArrowInDown', 'BIconBoxArrowInDownLeft', 'BIconBoxArrowInDownRight', 'BIconBoxArrowInLeft', 'BIconBoxArrowInRight', 'BIconBoxArrowInUp', 'BIconBoxArrowInUpLeft', 'BIconBoxArrowInUpRight', 'BIconBoxArrowLeft', 'BIconBoxArrowRight', 'BIconBoxArrowUp', 'BIconBoxArrowUpLeft', 'BIconBoxArrowUpRight', 'BIconBraces', 'BIconBriefcase', 'BIconBriefcaseFill', 'BIconBrightnessAltHigh', 'BIconBrightnessAltHighFill', 'BIconBrightnessAltLow', 'BIconBrightnessAltLowFill', 'BIconBrightnessHigh', 'BIconBrightnessHighFill', 'BIconBrightnessLow', 'BIconBrightnessLowFill', 'BIconBrush', 'BIconBucket', 'BIconBucketFill', 'BIconBuilding', 'BIconBullseye', 'BIconCalendar', 'BIconCalendarFill', 'BIconCamera', 'BIconCameraVideo', 'BIconCameraVideoFill', 'BIconCapslock', 'BIconCapslockFill', 'BIconCardChecklist', 'BIconCardHeading', 'BIconCardImage', 'BIconCardList', 'BIconCardText', 'BIconCaretDown', 'BIconCaretDownFill', 'BIconCaretLeft', 'BIconCaretLeftFill', 'BIconCaretRight', 'BIconCaretRightFill', 'BIconCaretUp', 'BIconCaretUpFill', 'BIconChat', 'BIconChatDots', 'BIconChatDotsFill', 'BIconChatFill', 'BIconChatQuote', 'BIconChatQuoteFill', 'BIconChatSquare', 'BIconChatSquareDots', 'BIconChatSquareDotsFill', 'BIconChatSquareFill', 'BIconChatSquareQuote', 'BIconChatSquareQuoteFill', 'BIconCheck', 'BIconCheckAll', 'BIconCheckBox', 'BIconCheckCircle', 'BIconChevronBarContract', 'BIconChevronBarDown', 'BIconChevronBarExpand', 'BIconChevronBarLeft', 'BIconChevronBarRight', 'BIconChevronBarUp', 'BIconChevronCompactDown', 'BIconChevronCompactLeft', 'BIconChevronCompactRight', 'BIconChevronCompactUp', 'BIconChevronContract', 'BIconChevronDoubleDown', 'BIconChevronDoubleLeft', 'BIconChevronDoubleRight', 'BIconChevronDoubleUp', 'BIconChevronDown', 'BIconChevronExpand', 'BIconChevronLeft', 'BIconChevronRight', 'BIconChevronUp', 'BIconCircle', 'BIconCircleFill', 'BIconCircleHalf', 'BIconCircleSquare', 'BIconClipboard', 'BIconClipboardData', 'BIconClock', 'BIconClockFill', 'BIconClockHistory', 'BIconCloud', 'BIconCloudDownload', 'BIconCloudFill', 'BIconCloudUpload', 'BIconCode', 'BIconCodeSlash', 'BIconCollection', 'BIconCollectionFill', 'BIconCollectionPlay', 'BIconCollectionPlayFill', 'BIconColumns', 'BIconColumnsGap', 'BIconCommand', 'BIconCompass', 'BIconCone', 'BIconConeStriped', 'BIconController', 'BIconCreditCard', 'BIconCrop', 'BIconCursor', 'BIconCursorFill', 'BIconCursorText', 'BIconDash', 'BIconDashCircle', 'BIconDashCircleFill', 'BIconDashSquare', 'BIconDashSquareFill', 'BIconDiamond', 'BIconDiamondFill', 'BIconDiamondHalf', 'BIconDisplay', 'BIconDisplayFill', 'BIconDot', 'BIconDownload', 'BIconDroplet', 'BIconDropletFill', 'BIconDropletHalf', 'BIconEgg', 'BIconEggFill', 'BIconEggFried', 'BIconEject', 'BIconEjectFill', 'BIconEnvelope', 'BIconEnvelopeFill', 'BIconEnvelopeOpen', 'BIconEnvelopeOpenFill', 'BIconExclamation', 'BIconExclamationCircle', 'BIconExclamationCircleFill', 'BIconExclamationDiamond', 'BIconExclamationDiamondFill', 'BIconExclamationOctagon', 'BIconExclamationOctagonFill', 'BIconExclamationSquare', 'BIconExclamationSquareFill', 'BIconExclamationTriangle', 'BIconExclamationTriangleFill', 'BIconExclude', 'BIconEye', 'BIconEyeFill', 'BIconEyeSlash', 'BIconEyeSlashFill', 'BIconFile', 'BIconFileArrowDown', 'BIconFileArrowUp', 'BIconFileBreak', 'BIconFileCheck', 'BIconFileCode', 'BIconFileDiff', 'BIconFileEarmark', 'BIconFileEarmarkArrowDown', 'BIconFileEarmarkArrowUp', 'BIconFileEarmarkBreak', 'BIconFileEarmarkCheck', 'BIconFileEarmarkCode', 'BIconFileEarmarkDiff', 'BIconFileEarmarkMinus', 'BIconFileEarmarkPlus', 'BIconFileEarmarkRuled', 'BIconFileEarmarkSpreadsheet', 'BIconFileEarmarkText', 'BIconFileEarmarkZip', 'BIconFileMinus', 'BIconFilePlus', 'BIconFilePost', 'BIconFileRichtext', 'BIconFileRuled', 'BIconFileSpreadsheet', 'BIconFileText', 'BIconFileZip', 'BIconFiles', 'BIconFilesAlt', 'BIconFilm', 'BIconFilter', 'BIconFilterLeft', 'BIconFilterRight', 'BIconFlag', 'BIconFlagFill', 'BIconFolder', 'BIconFolderCheck', 'BIconFolderFill', 'BIconFolderMinus', 'BIconFolderPlus', 'BIconFolderSymlink', 'BIconFolderSymlinkFill', 'BIconFonts', 'BIconForward', 'BIconForwardFill', 'BIconFullscreen', 'BIconFullscreenExit', 'BIconFunnel', 'BIconFunnelFill', 'BIconGear', 'BIconGearFill', 'BIconGearWide', 'BIconGearWideConnected', 'BIconGem', 'BIconGeo', 'BIconGeoAlt', 'BIconGift', 'BIconGiftFill', 'BIconGraphDown', 'BIconGraphUp', 'BIconGrid', 'BIconGrid1x2', 'BIconGrid1x2Fill', 'BIconGrid3x2', 'BIconGrid3x2Gap', 'BIconGrid3x2GapFill', 'BIconGrid3x3', 'BIconGrid3x3Gap', 'BIconGrid3x3GapFill', 'BIconGridFill', 'BIconHammer', 'BIconHash', 'BIconHeart', 'BIconHeartFill', 'BIconHeartHalf', 'BIconHouse', 'BIconHouseDoor', 'BIconHouseDoorFill', 'BIconHouseFill', 'BIconHr', 'BIconImage', 'BIconImageAlt', 'BIconImageFill', 'BIconImages', 'BIconInbox', 'BIconInboxFill', 'BIconInboxes', 'BIconInboxesFill', 'BIconInfo', 'BIconInfoCircle', 'BIconInfoCircleFill', 'BIconInfoSquare', 'BIconInfoSquareFill', 'BIconIntersect', 'BIconJustify', 'BIconJustifyLeft', 'BIconJustifyRight', 'BIconKanban', 'BIconKanbanFill', 'BIconLaptop', 'BIconLayers', 'BIconLayersFill', 'BIconLayersHalf', 'BIconLayoutSidebar', 'BIconLayoutSidebarInset', 'BIconLayoutSidebarInsetReverse', 'BIconLayoutSidebarReverse', 'BIconLayoutSplit', 'BIconLayoutTextSidebar', 'BIconLayoutTextSidebarReverse', 'BIconLayoutTextWindow', 'BIconLayoutTextWindowReverse', 'BIconLayoutThreeColumns', 'BIconLayoutWtf', 'BIconLifePreserver', 'BIconLightning', 'BIconLightningFill', 'BIconLink', 'BIconLink45deg', 'BIconList', 'BIconListCheck', 'BIconListNested', 'BIconListOl', 'BIconListTask', 'BIconListUl', 'BIconLock', 'BIconLockFill', 'BIconMap', 'BIconMic', 'BIconMicFill', 'BIconMicMute', 'BIconMicMuteFill', 'BIconMoon', 'BIconMusicNote', 'BIconMusicNoteBeamed', 'BIconMusicNoteList', 'BIconMusicPlayer', 'BIconMusicPlayerFill', 'BIconNewspaper', 'BIconOctagon', 'BIconOctagonFill', 'BIconOctagonHalf', 'BIconOption', 'BIconOutlet', 'BIconPaperclip', 'BIconPause', 'BIconPauseFill', 'BIconPen', 'BIconPencil', 'BIconPencilSquare', 'BIconPentagon', 'BIconPentagonFill', 'BIconPentagonHalf', 'BIconPeople', 'BIconPeopleCircle', 'BIconPeopleFill', 'BIconPerson', 'BIconPersonBoundingBox', 'BIconPersonCheck', 'BIconPersonCheckFill', 'BIconPersonDash', 'BIconPersonDashFill', 'BIconPersonFill', 'BIconPersonLinesFill', 'BIconPersonPlus', 'BIconPersonPlusFill', 'BIconPersonSquare', 'BIconPhone', 'BIconPhoneLandscape', 'BIconPieChart', 'BIconPieChartFill', 'BIconPip', 'BIconPipFill', 'BIconPlay', 'BIconPlayFill', 'BIconPlug', 'BIconPlus', 'BIconPlusCircle', 'BIconPlusCircleFill', 'BIconPlusSquare', 'BIconPlusSquareFill', 'BIconPower', 'BIconPuzzle', 'BIconPuzzleFill', 'BIconQuestion', 'BIconQuestionCircle', 'BIconQuestionCircleFill', 'BIconQuestionDiamond', 'BIconQuestionDiamondFill', 'BIconQuestionOctagon', 'BIconQuestionOctagonFill', 'BIconQuestionSquare', 'BIconQuestionSquareFill', 'BIconReply', 'BIconReplyAll', 'BIconReplyAllFill', 'BIconReplyFill', 'BIconScrewdriver', 'BIconSearch', 'BIconServer', 'BIconShield', 'BIconShieldFill', 'BIconShieldLock', 'BIconShieldLockFill', 'BIconShieldShaded', 'BIconShift', 'BIconShiftFill', 'BIconShuffle', 'BIconSkipBackward', 'BIconSkipBackwardFill', 'BIconSkipEnd', 'BIconSkipEndFill', 'BIconSkipForward', 'BIconSkipForwardFill', 'BIconSkipStart', 'BIconSkipStartFill', 'BIconSlash', 'BIconSlashCircle', 'BIconSlashCircleFill', 'BIconSlashSquare', 'BIconSlashSquareFill', 'BIconSliders', 'BIconSoundwave', 'BIconSpeaker', 'BIconSquare', 'BIconSquareFill', 'BIconSquareHalf', 'BIconStar', 'BIconStarFill', 'BIconStarHalf', 'BIconStop', 'BIconStopFill', 'BIconStopwatch', 'BIconStopwatchFill', 'BIconSubtract', 'BIconSun', 'BIconTable', 'BIconTablet', 'BIconTabletLandscape', 'BIconTag', 'BIconTagFill', 'BIconTerminal', 'BIconTerminalFill', 'BIconTextCenter', 'BIconTextIndentLeft', 'BIconTextIndentRight', 'BIconTextLeft', 'BIconTextRight', 'BIconTextarea', 'BIconTextareaT', 'BIconThreeDots', 'BIconThreeDotsVertical', 'BIconToggleOff', 'BIconToggleOn', 'BIconToggles', 'BIconTools', 'BIconTrash', 'BIconTrash2', 'BIconTrash2Fill', 'BIconTrashFill', 'BIconTriangle', 'BIconTriangleFill', 'BIconTriangleHalf', 'BIconTrophy', 'BIconTv', 'BIconTvFill', 'BIconType', 'BIconTypeBold', 'BIconTypeH1', 'BIconTypeH2', 'BIconTypeH3', 'BIconTypeItalic', 'BIconTypeStrikethrough', 'BIconTypeUnderline', 'BIconUnion', 'BIconUnlock', 'BIconUnlockFill', 'BIconUpload', 'BIconViewList', 'BIconViewStacked', 'BIconVolumeDown', 'BIconVolumeDownFill', 'BIconVolumeMute', 'BIconVolumeMuteFill', 'BIconVolumeUp', 'BIconVolumeUpFill', 'BIconVr', 'BIconWallet', 'BIconWatch', 'BIconWifi', 'BIconWindow', 'BIconWrench', 'BIconX', 'BIconXCircle', 'BIconXCircleFill', 'BIconXDiamond', 'BIconXDiamondFill', 'BIconXOctagon', 'BIconXOctagonFill', 'BIconXSquare', 'BIconXSquareFill']; // Export the icons plugin

export var IconsPlugin = /*#__PURE__*/pluginFactoryNoConfig({
  components: {
    // Icon helper component
    BIcon: BIcon,
    // Icon stacking component
    BIconstack: BIconstack,
    // BootstrapVue custom icon components
    BIconBlank: BIconBlank,
    // Bootstrap icon components
    BIconAlarm: BIconAlarm,
    BIconAlarmFill: BIconAlarmFill,
    BIconAlt: BIconAlt,
    BIconApp: BIconApp,
    BIconAppIndicator: BIconAppIndicator,
    BIconArchive: BIconArchive,
    BIconArchiveFill: BIconArchiveFill,
    BIconArrow90degDown: BIconArrow90degDown,
    BIconArrow90degLeft: BIconArrow90degLeft,
    BIconArrow90degRight: BIconArrow90degRight,
    BIconArrow90degUp: BIconArrow90degUp,
    BIconArrowBarDown: BIconArrowBarDown,
    BIconArrowBarLeft: BIconArrowBarLeft,
    BIconArrowBarRight: BIconArrowBarRight,
    BIconArrowBarUp: BIconArrowBarUp,
    BIconArrowClockwise: BIconArrowClockwise,
    BIconArrowCounterclockwise: BIconArrowCounterclockwise,
    BIconArrowDown: BIconArrowDown,
    BIconArrowDownLeft: BIconArrowDownLeft,
    BIconArrowDownRight: BIconArrowDownRight,
    BIconArrowDownShort: BIconArrowDownShort,
    BIconArrowLeft: BIconArrowLeft,
    BIconArrowLeftRight: BIconArrowLeftRight,
    BIconArrowLeftShort: BIconArrowLeftShort,
    BIconArrowRepeat: BIconArrowRepeat,
    BIconArrowReturnLeft: BIconArrowReturnLeft,
    BIconArrowReturnRight: BIconArrowReturnRight,
    BIconArrowRight: BIconArrowRight,
    BIconArrowRightShort: BIconArrowRightShort,
    BIconArrowUp: BIconArrowUp,
    BIconArrowUpDown: BIconArrowUpDown,
    BIconArrowUpLeft: BIconArrowUpLeft,
    BIconArrowUpRight: BIconArrowUpRight,
    BIconArrowUpShort: BIconArrowUpShort,
    BIconArrowsAngleContract: BIconArrowsAngleContract,
    BIconArrowsAngleExpand: BIconArrowsAngleExpand,
    BIconArrowsCollapse: BIconArrowsCollapse,
    BIconArrowsExpand: BIconArrowsExpand,
    BIconArrowsFullscreen: BIconArrowsFullscreen,
    BIconArrowsMove: BIconArrowsMove,
    BIconAspectRatio: BIconAspectRatio,
    BIconAspectRatioFill: BIconAspectRatioFill,
    BIconAt: BIconAt,
    BIconAward: BIconAward,
    BIconAwardFill: BIconAwardFill,
    BIconBackspace: BIconBackspace,
    BIconBackspaceFill: BIconBackspaceFill,
    BIconBackspaceReverse: BIconBackspaceReverse,
    BIconBackspaceReverseFill: BIconBackspaceReverseFill,
    BIconBag: BIconBag,
    BIconBagFill: BIconBagFill,
    BIconBarChart: BIconBarChart,
    BIconBarChartFill: BIconBarChartFill,
    BIconBattery: BIconBattery,
    BIconBatteryCharging: BIconBatteryCharging,
    BIconBatteryFull: BIconBatteryFull,
    BIconBatteryHalf: BIconBatteryHalf,
    BIconBell: BIconBell,
    BIconBellFill: BIconBellFill,
    BIconBlockquoteLeft: BIconBlockquoteLeft,
    BIconBlockquoteRight: BIconBlockquoteRight,
    BIconBook: BIconBook,
    BIconBookHalf: BIconBookHalf,
    BIconBookmark: BIconBookmark,
    BIconBookmarkCheck: BIconBookmarkCheck,
    BIconBookmarkDash: BIconBookmarkDash,
    BIconBookmarkFill: BIconBookmarkFill,
    BIconBookmarkPlus: BIconBookmarkPlus,
    BIconBookmarks: BIconBookmarks,
    BIconBookmarksFill: BIconBookmarksFill,
    BIconBootstrap: BIconBootstrap,
    BIconBootstrapFill: BIconBootstrapFill,
    BIconBootstrapReboot: BIconBootstrapReboot,
    BIconBoundingBox: BIconBoundingBox,
    BIconBoundingBoxCircles: BIconBoundingBoxCircles,
    BIconBoxArrowDown: BIconBoxArrowDown,
    BIconBoxArrowDownLeft: BIconBoxArrowDownLeft,
    BIconBoxArrowDownRight: BIconBoxArrowDownRight,
    BIconBoxArrowInDown: BIconBoxArrowInDown,
    BIconBoxArrowInDownLeft: BIconBoxArrowInDownLeft,
    BIconBoxArrowInDownRight: BIconBoxArrowInDownRight,
    BIconBoxArrowInLeft: BIconBoxArrowInLeft,
    BIconBoxArrowInRight: BIconBoxArrowInRight,
    BIconBoxArrowInUp: BIconBoxArrowInUp,
    BIconBoxArrowInUpLeft: BIconBoxArrowInUpLeft,
    BIconBoxArrowInUpRight: BIconBoxArrowInUpRight,
    BIconBoxArrowLeft: BIconBoxArrowLeft,
    BIconBoxArrowRight: BIconBoxArrowRight,
    BIconBoxArrowUp: BIconBoxArrowUp,
    BIconBoxArrowUpLeft: BIconBoxArrowUpLeft,
    BIconBoxArrowUpRight: BIconBoxArrowUpRight,
    BIconBraces: BIconBraces,
    BIconBriefcase: BIconBriefcase,
    BIconBriefcaseFill: BIconBriefcaseFill,
    BIconBrightnessAltHigh: BIconBrightnessAltHigh,
    BIconBrightnessAltHighFill: BIconBrightnessAltHighFill,
    BIconBrightnessAltLow: BIconBrightnessAltLow,
    BIconBrightnessAltLowFill: BIconBrightnessAltLowFill,
    BIconBrightnessHigh: BIconBrightnessHigh,
    BIconBrightnessHighFill: BIconBrightnessHighFill,
    BIconBrightnessLow: BIconBrightnessLow,
    BIconBrightnessLowFill: BIconBrightnessLowFill,
    BIconBrush: BIconBrush,
    BIconBucket: BIconBucket,
    BIconBucketFill: BIconBucketFill,
    BIconBuilding: BIconBuilding,
    BIconBullseye: BIconBullseye,
    BIconCalendar: BIconCalendar,
    BIconCalendarFill: BIconCalendarFill,
    BIconCamera: BIconCamera,
    BIconCameraVideo: BIconCameraVideo,
    BIconCameraVideoFill: BIconCameraVideoFill,
    BIconCapslock: BIconCapslock,
    BIconCapslockFill: BIconCapslockFill,
    BIconCardChecklist: BIconCardChecklist,
    BIconCardHeading: BIconCardHeading,
    BIconCardImage: BIconCardImage,
    BIconCardList: BIconCardList,
    BIconCardText: BIconCardText,
    BIconCaretDown: BIconCaretDown,
    BIconCaretDownFill: BIconCaretDownFill,
    BIconCaretLeft: BIconCaretLeft,
    BIconCaretLeftFill: BIconCaretLeftFill,
    BIconCaretRight: BIconCaretRight,
    BIconCaretRightFill: BIconCaretRightFill,
    BIconCaretUp: BIconCaretUp,
    BIconCaretUpFill: BIconCaretUpFill,
    BIconChat: BIconChat,
    BIconChatDots: BIconChatDots,
    BIconChatDotsFill: BIconChatDotsFill,
    BIconChatFill: BIconChatFill,
    BIconChatQuote: BIconChatQuote,
    BIconChatQuoteFill: BIconChatQuoteFill,
    BIconChatSquare: BIconChatSquare,
    BIconChatSquareDots: BIconChatSquareDots,
    BIconChatSquareDotsFill: BIconChatSquareDotsFill,
    BIconChatSquareFill: BIconChatSquareFill,
    BIconChatSquareQuote: BIconChatSquareQuote,
    BIconChatSquareQuoteFill: BIconChatSquareQuoteFill,
    BIconCheck: BIconCheck,
    BIconCheckAll: BIconCheckAll,
    BIconCheckBox: BIconCheckBox,
    BIconCheckCircle: BIconCheckCircle,
    BIconChevronBarContract: BIconChevronBarContract,
    BIconChevronBarDown: BIconChevronBarDown,
    BIconChevronBarExpand: BIconChevronBarExpand,
    BIconChevronBarLeft: BIconChevronBarLeft,
    BIconChevronBarRight: BIconChevronBarRight,
    BIconChevronBarUp: BIconChevronBarUp,
    BIconChevronCompactDown: BIconChevronCompactDown,
    BIconChevronCompactLeft: BIconChevronCompactLeft,
    BIconChevronCompactRight: BIconChevronCompactRight,
    BIconChevronCompactUp: BIconChevronCompactUp,
    BIconChevronContract: BIconChevronContract,
    BIconChevronDoubleDown: BIconChevronDoubleDown,
    BIconChevronDoubleLeft: BIconChevronDoubleLeft,
    BIconChevronDoubleRight: BIconChevronDoubleRight,
    BIconChevronDoubleUp: BIconChevronDoubleUp,
    BIconChevronDown: BIconChevronDown,
    BIconChevronExpand: BIconChevronExpand,
    BIconChevronLeft: BIconChevronLeft,
    BIconChevronRight: BIconChevronRight,
    BIconChevronUp: BIconChevronUp,
    BIconCircle: BIconCircle,
    BIconCircleFill: BIconCircleFill,
    BIconCircleHalf: BIconCircleHalf,
    BIconCircleSquare: BIconCircleSquare,
    BIconClipboard: BIconClipboard,
    BIconClipboardData: BIconClipboardData,
    BIconClock: BIconClock,
    BIconClockFill: BIconClockFill,
    BIconClockHistory: BIconClockHistory,
    BIconCloud: BIconCloud,
    BIconCloudDownload: BIconCloudDownload,
    BIconCloudFill: BIconCloudFill,
    BIconCloudUpload: BIconCloudUpload,
    BIconCode: BIconCode,
    BIconCodeSlash: BIconCodeSlash,
    BIconCollection: BIconCollection,
    BIconCollectionFill: BIconCollectionFill,
    BIconCollectionPlay: BIconCollectionPlay,
    BIconCollectionPlayFill: BIconCollectionPlayFill,
    BIconColumns: BIconColumns,
    BIconColumnsGap: BIconColumnsGap,
    BIconCommand: BIconCommand,
    BIconCompass: BIconCompass,
    BIconCone: BIconCone,
    BIconConeStriped: BIconConeStriped,
    BIconController: BIconController,
    BIconCreditCard: BIconCreditCard,
    BIconCrop: BIconCrop,
    BIconCursor: BIconCursor,
    BIconCursorFill: BIconCursorFill,
    BIconCursorText: BIconCursorText,
    BIconDash: BIconDash,
    BIconDashCircle: BIconDashCircle,
    BIconDashCircleFill: BIconDashCircleFill,
    BIconDashSquare: BIconDashSquare,
    BIconDashSquareFill: BIconDashSquareFill,
    BIconDiamond: BIconDiamond,
    BIconDiamondFill: BIconDiamondFill,
    BIconDiamondHalf: BIconDiamondHalf,
    BIconDisplay: BIconDisplay,
    BIconDisplayFill: BIconDisplayFill,
    BIconDot: BIconDot,
    BIconDownload: BIconDownload,
    BIconDroplet: BIconDroplet,
    BIconDropletFill: BIconDropletFill,
    BIconDropletHalf: BIconDropletHalf,
    BIconEgg: BIconEgg,
    BIconEggFill: BIconEggFill,
    BIconEggFried: BIconEggFried,
    BIconEject: BIconEject,
    BIconEjectFill: BIconEjectFill,
    BIconEnvelope: BIconEnvelope,
    BIconEnvelopeFill: BIconEnvelopeFill,
    BIconEnvelopeOpen: BIconEnvelopeOpen,
    BIconEnvelopeOpenFill: BIconEnvelopeOpenFill,
    BIconExclamation: BIconExclamation,
    BIconExclamationCircle: BIconExclamationCircle,
    BIconExclamationCircleFill: BIconExclamationCircleFill,
    BIconExclamationDiamond: BIconExclamationDiamond,
    BIconExclamationDiamondFill: BIconExclamationDiamondFill,
    BIconExclamationOctagon: BIconExclamationOctagon,
    BIconExclamationOctagonFill: BIconExclamationOctagonFill,
    BIconExclamationSquare: BIconExclamationSquare,
    BIconExclamationSquareFill: BIconExclamationSquareFill,
    BIconExclamationTriangle: BIconExclamationTriangle,
    BIconExclamationTriangleFill: BIconExclamationTriangleFill,
    BIconExclude: BIconExclude,
    BIconEye: BIconEye,
    BIconEyeFill: BIconEyeFill,
    BIconEyeSlash: BIconEyeSlash,
    BIconEyeSlashFill: BIconEyeSlashFill,
    BIconFile: BIconFile,
    BIconFileArrowDown: BIconFileArrowDown,
    BIconFileArrowUp: BIconFileArrowUp,
    BIconFileBreak: BIconFileBreak,
    BIconFileCheck: BIconFileCheck,
    BIconFileCode: BIconFileCode,
    BIconFileDiff: BIconFileDiff,
    BIconFileEarmark: BIconFileEarmark,
    BIconFileEarmarkArrowDown: BIconFileEarmarkArrowDown,
    BIconFileEarmarkArrowUp: BIconFileEarmarkArrowUp,
    BIconFileEarmarkBreak: BIconFileEarmarkBreak,
    BIconFileEarmarkCheck: BIconFileEarmarkCheck,
    BIconFileEarmarkCode: BIconFileEarmarkCode,
    BIconFileEarmarkDiff: BIconFileEarmarkDiff,
    BIconFileEarmarkMinus: BIconFileEarmarkMinus,
    BIconFileEarmarkPlus: BIconFileEarmarkPlus,
    BIconFileEarmarkRuled: BIconFileEarmarkRuled,
    BIconFileEarmarkSpreadsheet: BIconFileEarmarkSpreadsheet,
    BIconFileEarmarkText: BIconFileEarmarkText,
    BIconFileEarmarkZip: BIconFileEarmarkZip,
    BIconFileMinus: BIconFileMinus,
    BIconFilePlus: BIconFilePlus,
    BIconFilePost: BIconFilePost,
    BIconFileRichtext: BIconFileRichtext,
    BIconFileRuled: BIconFileRuled,
    BIconFileSpreadsheet: BIconFileSpreadsheet,
    BIconFileText: BIconFileText,
    BIconFileZip: BIconFileZip,
    BIconFiles: BIconFiles,
    BIconFilesAlt: BIconFilesAlt,
    BIconFilm: BIconFilm,
    BIconFilter: BIconFilter,
    BIconFilterLeft: BIconFilterLeft,
    BIconFilterRight: BIconFilterRight,
    BIconFlag: BIconFlag,
    BIconFlagFill: BIconFlagFill,
    BIconFolder: BIconFolder,
    BIconFolderCheck: BIconFolderCheck,
    BIconFolderFill: BIconFolderFill,
    BIconFolderMinus: BIconFolderMinus,
    BIconFolderPlus: BIconFolderPlus,
    BIconFolderSymlink: BIconFolderSymlink,
    BIconFolderSymlinkFill: BIconFolderSymlinkFill,
    BIconFonts: BIconFonts,
    BIconForward: BIconForward,
    BIconForwardFill: BIconForwardFill,
    BIconFullscreen: BIconFullscreen,
    BIconFullscreenExit: BIconFullscreenExit,
    BIconFunnel: BIconFunnel,
    BIconFunnelFill: BIconFunnelFill,
    BIconGear: BIconGear,
    BIconGearFill: BIconGearFill,
    BIconGearWide: BIconGearWide,
    BIconGearWideConnected: BIconGearWideConnected,
    BIconGem: BIconGem,
    BIconGeo: BIconGeo,
    BIconGeoAlt: BIconGeoAlt,
    BIconGift: BIconGift,
    BIconGiftFill: BIconGiftFill,
    BIconGraphDown: BIconGraphDown,
    BIconGraphUp: BIconGraphUp,
    BIconGrid: BIconGrid,
    BIconGrid1x2: BIconGrid1x2,
    BIconGrid1x2Fill: BIconGrid1x2Fill,
    BIconGrid3x2: BIconGrid3x2,
    BIconGrid3x2Gap: BIconGrid3x2Gap,
    BIconGrid3x2GapFill: BIconGrid3x2GapFill,
    BIconGrid3x3: BIconGrid3x3,
    BIconGrid3x3Gap: BIconGrid3x3Gap,
    BIconGrid3x3GapFill: BIconGrid3x3GapFill,
    BIconGridFill: BIconGridFill,
    BIconHammer: BIconHammer,
    BIconHash: BIconHash,
    BIconHeart: BIconHeart,
    BIconHeartFill: BIconHeartFill,
    BIconHeartHalf: BIconHeartHalf,
    BIconHouse: BIconHouse,
    BIconHouseDoor: BIconHouseDoor,
    BIconHouseDoorFill: BIconHouseDoorFill,
    BIconHouseFill: BIconHouseFill,
    BIconHr: BIconHr,
    BIconImage: BIconImage,
    BIconImageAlt: BIconImageAlt,
    BIconImageFill: BIconImageFill,
    BIconImages: BIconImages,
    BIconInbox: BIconInbox,
    BIconInboxFill: BIconInboxFill,
    BIconInboxes: BIconInboxes,
    BIconInboxesFill: BIconInboxesFill,
    BIconInfo: BIconInfo,
    BIconInfoCircle: BIconInfoCircle,
    BIconInfoCircleFill: BIconInfoCircleFill,
    BIconInfoSquare: BIconInfoSquare,
    BIconInfoSquareFill: BIconInfoSquareFill,
    BIconIntersect: BIconIntersect,
    BIconJustify: BIconJustify,
    BIconJustifyLeft: BIconJustifyLeft,
    BIconJustifyRight: BIconJustifyRight,
    BIconKanban: BIconKanban,
    BIconKanbanFill: BIconKanbanFill,
    BIconLaptop: BIconLaptop,
    BIconLayers: BIconLayers,
    BIconLayersFill: BIconLayersFill,
    BIconLayersHalf: BIconLayersHalf,
    BIconLayoutSidebar: BIconLayoutSidebar,
    BIconLayoutSidebarInset: BIconLayoutSidebarInset,
    BIconLayoutSidebarInsetReverse: BIconLayoutSidebarInsetReverse,
    BIconLayoutSidebarReverse: BIconLayoutSidebarReverse,
    BIconLayoutSplit: BIconLayoutSplit,
    BIconLayoutTextSidebar: BIconLayoutTextSidebar,
    BIconLayoutTextSidebarReverse: BIconLayoutTextSidebarReverse,
    BIconLayoutTextWindow: BIconLayoutTextWindow,
    BIconLayoutTextWindowReverse: BIconLayoutTextWindowReverse,
    BIconLayoutThreeColumns: BIconLayoutThreeColumns,
    BIconLayoutWtf: BIconLayoutWtf,
    BIconLifePreserver: BIconLifePreserver,
    BIconLightning: BIconLightning,
    BIconLightningFill: BIconLightningFill,
    BIconLink: BIconLink,
    BIconLink45deg: BIconLink45deg,
    BIconList: BIconList,
    BIconListCheck: BIconListCheck,
    BIconListNested: BIconListNested,
    BIconListOl: BIconListOl,
    BIconListTask: BIconListTask,
    BIconListUl: BIconListUl,
    BIconLock: BIconLock,
    BIconLockFill: BIconLockFill,
    BIconMap: BIconMap,
    BIconMic: BIconMic,
    BIconMicFill: BIconMicFill,
    BIconMicMute: BIconMicMute,
    BIconMicMuteFill: BIconMicMuteFill,
    BIconMoon: BIconMoon,
    BIconMusicNote: BIconMusicNote,
    BIconMusicNoteBeamed: BIconMusicNoteBeamed,
    BIconMusicNoteList: BIconMusicNoteList,
    BIconMusicPlayer: BIconMusicPlayer,
    BIconMusicPlayerFill: BIconMusicPlayerFill,
    BIconNewspaper: BIconNewspaper,
    BIconOctagon: BIconOctagon,
    BIconOctagonFill: BIconOctagonFill,
    BIconOctagonHalf: BIconOctagonHalf,
    BIconOption: BIconOption,
    BIconOutlet: BIconOutlet,
    BIconPaperclip: BIconPaperclip,
    BIconPause: BIconPause,
    BIconPauseFill: BIconPauseFill,
    BIconPen: BIconPen,
    BIconPencil: BIconPencil,
    BIconPencilSquare: BIconPencilSquare,
    BIconPentagon: BIconPentagon,
    BIconPentagonFill: BIconPentagonFill,
    BIconPentagonHalf: BIconPentagonHalf,
    BIconPeople: BIconPeople,
    BIconPeopleCircle: BIconPeopleCircle,
    BIconPeopleFill: BIconPeopleFill,
    BIconPerson: BIconPerson,
    BIconPersonBoundingBox: BIconPersonBoundingBox,
    BIconPersonCheck: BIconPersonCheck,
    BIconPersonCheckFill: BIconPersonCheckFill,
    BIconPersonDash: BIconPersonDash,
    BIconPersonDashFill: BIconPersonDashFill,
    BIconPersonFill: BIconPersonFill,
    BIconPersonLinesFill: BIconPersonLinesFill,
    BIconPersonPlus: BIconPersonPlus,
    BIconPersonPlusFill: BIconPersonPlusFill,
    BIconPersonSquare: BIconPersonSquare,
    BIconPhone: BIconPhone,
    BIconPhoneLandscape: BIconPhoneLandscape,
    BIconPieChart: BIconPieChart,
    BIconPieChartFill: BIconPieChartFill,
    BIconPip: BIconPip,
    BIconPipFill: BIconPipFill,
    BIconPlay: BIconPlay,
    BIconPlayFill: BIconPlayFill,
    BIconPlug: BIconPlug,
    BIconPlus: BIconPlus,
    BIconPlusCircle: BIconPlusCircle,
    BIconPlusCircleFill: BIconPlusCircleFill,
    BIconPlusSquare: BIconPlusSquare,
    BIconPlusSquareFill: BIconPlusSquareFill,
    BIconPower: BIconPower,
    BIconPuzzle: BIconPuzzle,
    BIconPuzzleFill: BIconPuzzleFill,
    BIconQuestion: BIconQuestion,
    BIconQuestionCircle: BIconQuestionCircle,
    BIconQuestionCircleFill: BIconQuestionCircleFill,
    BIconQuestionDiamond: BIconQuestionDiamond,
    BIconQuestionDiamondFill: BIconQuestionDiamondFill,
    BIconQuestionOctagon: BIconQuestionOctagon,
    BIconQuestionOctagonFill: BIconQuestionOctagonFill,
    BIconQuestionSquare: BIconQuestionSquare,
    BIconQuestionSquareFill: BIconQuestionSquareFill,
    BIconReply: BIconReply,
    BIconReplyAll: BIconReplyAll,
    BIconReplyAllFill: BIconReplyAllFill,
    BIconReplyFill: BIconReplyFill,
    BIconScrewdriver: BIconScrewdriver,
    BIconSearch: BIconSearch,
    BIconServer: BIconServer,
    BIconShield: BIconShield,
    BIconShieldFill: BIconShieldFill,
    BIconShieldLock: BIconShieldLock,
    BIconShieldLockFill: BIconShieldLockFill,
    BIconShieldShaded: BIconShieldShaded,
    BIconShift: BIconShift,
    BIconShiftFill: BIconShiftFill,
    BIconShuffle: BIconShuffle,
    BIconSkipBackward: BIconSkipBackward,
    BIconSkipBackwardFill: BIconSkipBackwardFill,
    BIconSkipEnd: BIconSkipEnd,
    BIconSkipEndFill: BIconSkipEndFill,
    BIconSkipForward: BIconSkipForward,
    BIconSkipForwardFill: BIconSkipForwardFill,
    BIconSkipStart: BIconSkipStart,
    BIconSkipStartFill: BIconSkipStartFill,
    BIconSlash: BIconSlash,
    BIconSlashCircle: BIconSlashCircle,
    BIconSlashCircleFill: BIconSlashCircleFill,
    BIconSlashSquare: BIconSlashSquare,
    BIconSlashSquareFill: BIconSlashSquareFill,
    BIconSliders: BIconSliders,
    BIconSoundwave: BIconSoundwave,
    BIconSpeaker: BIconSpeaker,
    BIconSquare: BIconSquare,
    BIconSquareFill: BIconSquareFill,
    BIconSquareHalf: BIconSquareHalf,
    BIconStar: BIconStar,
    BIconStarFill: BIconStarFill,
    BIconStarHalf: BIconStarHalf,
    BIconStop: BIconStop,
    BIconStopFill: BIconStopFill,
    BIconStopwatch: BIconStopwatch,
    BIconStopwatchFill: BIconStopwatchFill,
    BIconSubtract: BIconSubtract,
    BIconSun: BIconSun,
    BIconTable: BIconTable,
    BIconTablet: BIconTablet,
    BIconTabletLandscape: BIconTabletLandscape,
    BIconTag: BIconTag,
    BIconTagFill: BIconTagFill,
    BIconTerminal: BIconTerminal,
    BIconTerminalFill: BIconTerminalFill,
    BIconTextCenter: BIconTextCenter,
    BIconTextIndentLeft: BIconTextIndentLeft,
    BIconTextIndentRight: BIconTextIndentRight,
    BIconTextLeft: BIconTextLeft,
    BIconTextRight: BIconTextRight,
    BIconTextarea: BIconTextarea,
    BIconTextareaT: BIconTextareaT,
    BIconThreeDots: BIconThreeDots,
    BIconThreeDotsVertical: BIconThreeDotsVertical,
    BIconToggleOff: BIconToggleOff,
    BIconToggleOn: BIconToggleOn,
    BIconToggles: BIconToggles,
    BIconTools: BIconTools,
    BIconTrash: BIconTrash,
    BIconTrash2: BIconTrash2,
    BIconTrash2Fill: BIconTrash2Fill,
    BIconTrashFill: BIconTrashFill,
    BIconTriangle: BIconTriangle,
    BIconTriangleFill: BIconTriangleFill,
    BIconTriangleHalf: BIconTriangleHalf,
    BIconTrophy: BIconTrophy,
    BIconTv: BIconTv,
    BIconTvFill: BIconTvFill,
    BIconType: BIconType,
    BIconTypeBold: BIconTypeBold,
    BIconTypeH1: BIconTypeH1,
    BIconTypeH2: BIconTypeH2,
    BIconTypeH3: BIconTypeH3,
    BIconTypeItalic: BIconTypeItalic,
    BIconTypeStrikethrough: BIconTypeStrikethrough,
    BIconTypeUnderline: BIconTypeUnderline,
    BIconUnion: BIconUnion,
    BIconUnlock: BIconUnlock,
    BIconUnlockFill: BIconUnlockFill,
    BIconUpload: BIconUpload,
    BIconViewList: BIconViewList,
    BIconViewStacked: BIconViewStacked,
    BIconVolumeDown: BIconVolumeDown,
    BIconVolumeDownFill: BIconVolumeDownFill,
    BIconVolumeMute: BIconVolumeMute,
    BIconVolumeMuteFill: BIconVolumeMuteFill,
    BIconVolumeUp: BIconVolumeUp,
    BIconVolumeUpFill: BIconVolumeUpFill,
    BIconVr: BIconVr,
    BIconWallet: BIconWallet,
    BIconWatch: BIconWatch,
    BIconWifi: BIconWifi,
    BIconWindow: BIconWindow,
    BIconWrench: BIconWrench,
    BIconX: BIconX,
    BIconXCircle: BIconXCircle,
    BIconXCircleFill: BIconXCircleFill,
    BIconXDiamond: BIconXDiamond,
    BIconXDiamondFill: BIconXDiamondFill,
    BIconXOctagon: BIconXOctagon,
    BIconXOctagonFill: BIconXOctagonFill,
    BIconXSquare: BIconXSquare,
    BIconXSquareFill: BIconXSquareFill
  }
}); // Export the BootstrapVueIcons plugin installer
// Mainly for the stand-alone bootstrap-vue-icons.xxx.js builds

export var BootstrapVueIcons = /*#__PURE__*/pluginFactoryNoConfig({
  plugins: {
    IconsPlugin: IconsPlugin
  }
}, {
  NAME: 'BootstrapVueIcons'
}); // --- END AUTO-GENERATED FILE ---


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/icons/plugin.js
// module id = 851
// module chunks = 0